module.exports = __webpack_public_path__ + "img/Slide7.8fbf2d40.png";